import request from '@/utils/request'

let PropertyApi = {

  /*物业列表*/
  list(data) {
    return request._post('/shop/plus.property.Index/index', data);
},
/*添加物业*/
add(data) {
    return request._post('/shop/plus.property.Index/add', data);
},
/*修改物业*/
edit(data) {
    return request._post('/shop/plus.property.Index/edit', data);
},
/*删除物业*/
del(data) {
    return request._post('/shop/plus.property.Index/del', data);
},
/*物业详情*/
detail(data) {
  return request._post('/shop/plus.property.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.property.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.property.Setting/getSetting', data, errorback);
    },
}
export default PropertyApi;



// WEBPACK FOOTER //
// ./src/api/property.js